import { useKeycloak } from '@lib/keycloak'
import ROLES from '@roles'
import { computed } from 'vue'

export const useRoles = () => {
    const keycloak = useKeycloak()

    const hasCreateReplacementRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.CREATE_REPLACEMENT_TICKET)
    })

    const hasTerminateTicketRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.TERMINATE_TICKET)
    })

    const hasDeleteTicketRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.DELETE_TICKET)
    })

    const hasCreateNewTicketHolderRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.CREATE_NEW_TICKET_HOLDER)
    })

    const hasEditTicketHolderRole = computed(() => {
        return keycloak.resourceAccess.csp.roles.includes(ROLES.EDIT_TICKET_HOLDERS)
    })

    const hasEditTicketHolderEmailRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.EDIT_TICKET_HOLDERS_EMAIL)
    })

    const hasEditTicketHoldersCostBearerRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.EDIT_TICKET_HOLDERS_COST_BEARER)
    })

    const hasAdminRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.ADMINISTRATOR)
    })

    const hasCorporationScopeSchool = computed(() => {
        return keycloak.hasResourceRole(ROLES.CORPORATION_SCOPE_SCHOOLS)
    })

    const hasCorporationScopeSchoolAuthorities = computed(() => {
        return keycloak.hasResourceRole(ROLES.CORPORATION_SCOPE_SCHOOL_AUTHORITIES)
    })

    const hasScheduledSchoolChangeRole = computed(() => {
        return keycloak.hasResourceRole(ROLES.SCHEDULED_SCHOOL_CHANGE)
    })

    const hasRole = (role) => {
        return keycloak.hasResourceRole(role)
    }

    return {
        hasRole,
        hasCorporationScopeSchool,
        hasCorporationScopeSchoolAuthorities,
        hasAdminRole,
        hasCreateReplacementRole,
        hasTerminateTicketRole,
        hasDeleteTicketRole,
        hasCreateNewTicketHolderRole,
        hasEditTicketHolderRole,
        hasEditTicketHolderEmailRole,
        hasScheduledSchoolChangeRole,
        hasEditTicketHoldersCostBearerRole
    }
}